import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, Trash2, X } from 'lucide-react';

export default function DeleteConfirmModal({ isOpen, onClose, onConfirm, title = "Confirm Delete", message = "Are you sure you want to delete this record? This action cannot be undone.", itemName }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('form-is-open');
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.body.classList.remove('form-is-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="form-overlay" onClick={onClose}>
      <div className="form-container" style={{ maxWidth: '420px', padding: '24px', animation: 'scaleUp 0.25s ease forwards' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text-primary)', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AlertTriangle style={{ color: '#ef4444' }} size={20} />
            {title}
          </h2>
          <button className="modal-close-btn" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)' }}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body" style={{ marginBottom: '24px' }}>
          <p style={{ margin: '0 0 12px 0', fontSize: '0.95rem', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
            {message}
          </p>
          {itemName && (
            <div style={{ 
              background: 'rgba(239, 68, 68, 0.06)', 
              borderLeft: '3px solid #ef4444', 
              padding: '10px 14px', 
              borderRadius: '4px',
              fontWeight: 500,
              fontSize: '0.9rem',
              color: '#ef4444'
            }}>
              {itemName}
            </div>
          )}
        </div>

        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button className="form-cancel-btn" onClick={onClose} style={{ padding: '10px 18px', border: '1px solid var(--border-color)', borderRadius: '6px', background: 'transparent', color: 'var(--text-secondary)', cursor: 'pointer', fontWeight: 500 }}>
            Cancel
          </button>
          <button className="add-btn" onClick={onConfirm} style={{ padding: '10px 18px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Trash2 size={16} />
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
